import React from 'react'
import ListOptions from './ListOptions/ListOptions'
import ExportListButton from './ExportListButton/ExportListButton'
import PropTypes from 'prop-types'
import FullscreenButton from '../HeadBar/FullscreenButton/FullscreenButton'
import RefreshPageButton from '../../PropertySearch/HeadBar/RefreshPageButton/RefreshPageButton'
const HeadBar = props => {

    return (
        <>
            <div className="w-full grid  grid-cols-2 items-center p-4">
                <div className="overflow-hidden font-semibold ">
                    {`Property List: ${props.listName}`}
                </div>
                {/* <div className="md:col-span-1 overflow-hidden ">
                </div> */}
                <div className="overflow-hidden ">
                    <div className="flex justify-end space-x-4">
                        <div>
                            <RefreshPageButton />
                        </div>
                        <div>
                            <FullscreenButton />
                        </div>
                        <div>
                            <ExportListButton />
                        </div>
                        <div>
                            <ListOptions />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

HeadBar.propTypes = {
    listName: PropTypes.string
}

export default HeadBar
